module.exports = __webpack_public_path__ + "img/typing-faster.ebd52062.jpg";